import { Container, Nav } from "react-bootstrap";
import { Link, useLocation } from 'react-router-dom';
import ErrorBoundary from "../components/ErrorBoundary";
import ArticleGlobal from "../components/global/ArticleGlobal";
import { OptionsSidebar } from "../navigation";
import MainLayout from "./MainLayout";

const OptionsLayout = ({ children }) => {
	const location = useLocation();

	const isActive = (slug) => {
		return location.pathname.startsWith(slug);
	};

	return (
		<MainLayout>
			<Container>
				<div
					style={{
						display: "grid",
						gridTemplateColumns: "auto 1fr",
						gap: "1rem",
					}}>
					<ErrorBoundary fallback="error in aside">
						<aside className="text-end pt-4">
							<Nav vertical="true" className="flex-column">
								{OptionsSidebar.map((item, index) => {
									const active = isActive(item.slug);

									return (
										<Nav.Item key={index}>
											<Nav.Link
												as={Link}
												to={item.slug}
												className={`custom-side-nav-link ${active ? 'active' : ''}`}
											>
												<div className="d-flex flex-row align-items-center">
													<item.ico className="me-2" style={{ color: active ? '#ff91f4' : 'white' }} />

													<b>{item.text}</b>
												</div>
											</Nav.Link>
										</Nav.Item>
									);
								})}

							</Nav>
						</aside>
					</ErrorBoundary>
					<ErrorBoundary fallback="error in content">
						<ArticleGlobal >{children}</ArticleGlobal>
					</ErrorBoundary>
				</div>
			</Container>
		</MainLayout>
	);
};

export default OptionsLayout;
